import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TvsReportsComponent } from './tvs-reports.component';

const routes: Routes = [
  { path: ':email/:id', component: TvsReportsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TvsReportsRoutingModule {}
